const connector = {
    general: '連接器發生錯誤：{{errorDescription}}',
    not_found: '找不到可用的 {{type}} 類型的連接器',
    not_enabled: '連接器尚未啟用',
    invalid_metadata: '連接器中繼資料參數錯誤',
    invalid_config_guard: '連接器設定驗證失敗',
    unexpected_type: '連接器類型錯誤',
    invalid_request_parameters: '請求參數錯誤',
    insufficient_request_parameters: '請求參數缺失',
    invalid_config: '連接器配置錯誤',
    invalid_certificate: '連接器的憑證無效，請確保憑證使用隱私增強郵件格式（PEM）編碼。',
    invalid_response: '連接器錯誤響應',
    template_not_found: '無法從連接器配置中找到對應的模板',
    template_not_supported: '連接器不支援此模板類型',
    rate_limit_exceeded: '觸發速率限制。請稍後再試。',
    usage_limit_exceeded: '已達到電子郵件服務使用上限。',
    not_implemented: '方法 {{method}} 尚未實現',
    social_invalid_access_token: '當前連接器的access_token無效',
    invalid_auth_code: '當前連接器的授權碼無效',
    social_invalid_id_token: '當前連接器的id_token無效',
    authorization_failed: '用戶授權流程失敗',
    social_auth_code_invalid: '無法獲取access_token，請檢查授權code是否有效',
    more_than_one_sms: '同時存在超過 1 個短信連接器',
    more_than_one_email: '同時存在超過 1 個郵件連接器',
    more_than_one_connector_factory: '找到多個連接器工廠（識別碼為 {{connectorIds}}），請刪除多餘項。',
    db_connector_type_mismatch: '數據庫中存在一個類型不匹配的連接。',
    not_found_with_connector_id: '找不到指定連接器識別碼對應的連接器',
    multiple_instances_not_supported: '你選擇的連接器不支持創建多實例。',
    invalid_type_for_syncing_profile: '只有社交連接器可以開啟用戶檔案同步。',
    can_not_modify_target: '不可修改連接器的目標（target）欄位。',
    should_specify_target: '必須指定目標（target）值。',
    multiple_target_with_same_platform: '同一平台上的多個社交連接器不能使用相同的目標（target）。',
    cannot_overwrite_metadata_for_non_standard_connector: '不可覆蓋該連接器的中繼資料參數。',
    email_connector: {
        bulk_deletion_no_filter: '必須提供至少一個篩選條件才能根據屬性執行批量刪除。支持的屬性是：{{properties, list(type:conjunction)}}。',
    },
    token_storage_not_supported: '此連接器不支持令牌存儲。',
};
export default Object.freeze(connector);
